import { useState, useCallback } from 'react';

export type J219Mode = 'browse' | 'add' | 'edit';

export interface UseJ219Mode {
  mode: J219Mode;
  isEditing: boolean;
  enterAdd: () => void;
  enterEdit: () => void;
  enterBrowse: () => void;
}

/**
 * useJ219Mode — manages the form mode (browse / add / edit).
 */
export function useJ219Mode(): UseJ219Mode {
  const [mode, setMode] = useState<J219Mode>('browse');

  const enterAdd = useCallback(() => setMode('add'), []);
  const enterEdit = useCallback(() => setMode('edit'), []);
  const enterBrowse = useCallback(() => setMode('browse'), []);

  return {
    mode,
    isEditing: mode === 'add' || mode === 'edit',
    enterAdd,
    enterEdit,
    enterBrowse,
  };
}
